// Cuánto espera la pantalla a que termine una publicación antes de darla por trabada
// (ADR-2026-10-06-la-pantalla-no-se-rinde-mientras-se-publica).
//
// Antes eran 130 s fijos. Publicar en Tiendanube tarda unos 7 s por producto (prueba del 6/10, 10 productos en 71 s),
// así que un lanzamiento de 20 productos pasaba el tope: la pantalla avisaba "no se confirmó" y marcaba error mientras
// el backend seguía publicando bien. Ahora el tope crece con el tamaño, con margen de sobra, y hasta 30 min.
const BASE_MS = 130_000;
const POR_PRODUCTO_MS = 15_000;
const POR_FOTO_MS = 5_000;
const TOPE_MS = 30 * 60_000;

export function limiteDeEsperaMs(p: { productos: number; fotos?: number }): number {
  const productos = Math.max(0, p.productos);
  const fotos = Math.max(0, p.fotos ?? 0);
  return Math.min(TOPE_MS, BASE_MS + productos * POR_PRODUCTO_MS + fotos * POR_FOTO_MS);
}
